var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.52 30.45H85.08V10L105.52 30.45Z",
    fill: "#E9AF34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.52 30.45H85.08V10L105.52 30.45Z",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.69 67.1808L66.8323 134.135L133.787 139.993L139.644 73.0385L72.69 67.1808Z",
    fill: "#DB6C2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.69 67.1808L66.8323 134.135L133.787 139.993L139.644 73.0385L72.69 67.1808Z",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.79 120.26L83.0499 116.96L99.9499 97.6899L107.34 108.79L111.53 104.4L120.79 120.26Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 93.45C123.427 94.3001 123.104 95.1094 122.571 95.7756C122.038 96.4418 121.319 96.9347 120.506 97.1921C119.692 97.4494 118.821 97.4596 118.002 97.2212C117.182 96.9829 116.452 96.5067 115.904 95.8532C115.356 95.1996 115.013 94.3979 114.921 93.5498C114.829 92.7016 114.99 91.8451 115.385 91.0888C115.779 90.3324 116.39 89.7102 117.138 89.301C117.887 88.8918 118.74 88.7139 119.59 88.79C120.726 88.8917 121.775 89.4391 122.507 90.3125C123.24 91.1859 123.597 92.314 123.5 93.45Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.05 120.76H22C21.2537 120.761 20.5145 120.615 19.8248 120.33C19.135 120.045 18.5084 119.627 17.9807 119.099C17.453 118.572 17.0346 117.945 16.7496 117.255C16.4647 116.565 16.3186 115.826 16.32 115.08V17.38C16.32 15.8735 16.9184 14.4288 17.9836 13.3636C19.0488 12.2984 20.4935 11.7 22 11.7H85.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.68 28.74V64.75",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5199 41.64H86.5299",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5199 51.16H86.5299",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5199 60.5699H63.0599",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5199 86.09H64.7199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5199 95.6H63.5799",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagePhoto);
export default __webpack_public_path__ + "static/media/page_photo.b5a1348a2450f78356f003b00ffb3a94.svg";
export { ForwardRef as ReactComponent };